
// export const BASE_URL = "http://localhost:3045/"
// export const IMAGE_URL = "http://localhost:3045/"


export const BASE_URL = "https://pacifricab.sigisolutions.net/"
export const IMAGE_URL = "https://pacifricab.sigisolutions.net/"



